const API_PREFIX = '/api';

export const BLOG_ENDPOINTS = {
  // Public endpoints
  public: {
    getBlog: (id: number) => `${API_PREFIX}/public/blogs/${id}`,
    getBlogBySlug: (slug: string) => `${API_PREFIX}/public/blogs/slug/${slug}`,
    getBlogCategories: (blogId: number) => `${API_PREFIX}/public/blogs/${blogId}/categories`,
    getBlogPosts: (blogId: number) => `${API_PREFIX}/public/blogs/${blogId}/posts`,
    getCategoryPosts: (categoryId: number) => `${API_PREFIX}/public/categories/${categoryId}/posts`,
    getPost: (id: number) => `${API_PREFIX}/public/posts/${id}`,
    getPostBySlug: (slug: string) => `${API_PREFIX}/public/posts/slug/${slug}`,
    getPostImages: (postId: number) => `${API_PREFIX}/public/posts/${postId}/images`,
  },

  // Admin endpoints
  admin: {
    // Blogs
    createBlog: `${API_PREFIX}/admin/blogs`,
    listMyBlogs: `${API_PREFIX}/admin/blogs`,
    getBlog: (id: number) => `${API_PREFIX}/admin/blogs/${id}`,
    getBlogPermissions: (id: number) => `${API_PREFIX}/admin/blogs/${id}/permissions`,
    uploadBlogMedia: (id: number) => `${API_PREFIX}/admin/blogs/${id}/media`,
    deleteBlogMedia: (id: number, fileId: string) => `${API_PREFIX}/admin/blogs/${id}/media/${encodeURIComponent(fileId)}`,
    getBlogDriveStatus: (id: number) => `${API_PREFIX}/admin/blogs/${id}/drive-status`,
    updateBlog: (id: number) => `${API_PREFIX}/admin/blogs/${id}`,
    deleteBlog: (id: number) => `${API_PREFIX}/admin/blogs/${id}`,
    addBlogAdmin: (blogId: number) => `${API_PREFIX}/admin/blogs/${blogId}/admins`,
    removeBlogAdmin: (blogId: number) => `${API_PREFIX}/admin/blogs/${blogId}/admins`,
    transferBlogOwnership: (blogId: number) => `${API_PREFIX}/admin/blogs/${blogId}/transfer-ownership`,
    getBlogCategories: (blogId: number) => `${API_PREFIX}/admin/blogs/${blogId}/categories`,
    getBlogPosts: (blogId: number) => `${API_PREFIX}/admin/blogs/${blogId}/posts`,

    // Categories
    createCategory: `${API_PREFIX}/admin/categories`,
    getCategory: (id: number) => `${API_PREFIX}/admin/categories/${id}`,
    updateCategory: (id: number) => `${API_PREFIX}/admin/categories/${id}`,
    deleteCategory: (id: number) => `${API_PREFIX}/admin/categories/${id}`,

    // Posts
    createPost: `${API_PREFIX}/admin/posts`,
    createDraftPost: (blogId: number) => `${API_PREFIX}/admin/blogs/${blogId}/posts/create-post`,
    listMyPosts: `${API_PREFIX}/admin/posts`,
    getPost: (id: number) => `${API_PREFIX}/admin/posts/${id}`,
    updatePost: (id: number) => `${API_PREFIX}/admin/posts/${id}`,
    publishPost: (id: number) => `${API_PREFIX}/admin/posts/${id}/publish-post`,
    deletePost: (id: number) => `${API_PREFIX}/admin/posts/${id}`,
    getPostImages: (postId: number) => `${API_PREFIX}/admin/posts/${postId}/images`,
    addPostImage: (postId: number) => `${API_PREFIX}/admin/posts/${postId}/images`,
    addPostImagesBatch: (postId: number) => `${API_PREFIX}/admin/posts/${postId}/images/batch`,
    removePostImage: (postId: number, imageId: number) => `${API_PREFIX}/admin/posts/${postId}/images/${imageId}`,
    updatePostImage: (postId: number, imageId: number) => `${API_PREFIX}/admin/posts/${postId}/images/${imageId}`,
  },
};
